//Cart Upsell Code
$(document).ready(function(){
  console.log("Cart upsell script loaded.");

  // Define our upsell products
  var upsells = [
    {
    id: 'wheelInstallationKit',
    handle: 'wheel-installation-kit-set',
    condition: function(cart) {
        var count = 0;
        cart.items.forEach(function(item) {
            if (item.product_type && item.product_type.toLowerCase() === 'wheels') {
                count += item.quantity;
            }
        });
        return count >= 4;
    },
    subtitle: 'Aftermarket wheels require aftermarket lugs for proper installation. ' + 
          'Our installation kit includes all necessary hardware in the correct sizes—lug nuts or bolts & hub-centric rings if needed.'
},

    {
      id: 'premiumWheelLocks',
      handle: 'premium-wheel-locks',
      condition: function(cart){
        // Fixed: Only count wheels, not the sum of wheels and tires
        var wheelCount = 0;
        cart.items.forEach(function(item){
          if(item.product_type && item.product_type.toLowerCase() === 'wheels'){
            wheelCount += item.quantity;
          }
        });
        return wheelCount >= 4;
      },
      subtitle: 'Anti-theft wheel locks to secure your wheels'
    },
    {
      id: 'tpmsSensors',
      handle: 'tpms-sensor-set-of-4',
      condition: function(cart){
        // Show TPMS sensors when either 4+ wheels OR 4+ tires are in cart
        var wheelCount = 0, tireCount = 0;
        cart.items.forEach(function(item){
          var pt = item.product_type ? item.product_type.toLowerCase() : "";
          if(pt === 'wheels') wheelCount += item.quantity;
          if(pt === 'tires') tireCount += item.quantity;
        });
        return wheelCount >= 4 || tireCount >= 4;
      },
      subtitle: 'Pre-programmed to your vehicle frequency & ready to install'
    },
    {
      id: 'hubCentricRings',
      handle: 'hub-centric-rings-set-of-4',
      condition: function(cart){
        var wheelCount = 0;
        cart.items.forEach(function(item){
          if(item.product_type && item.product_type.toLowerCase() === 'wheels'){
            wheelCount += item.quantity;
          }
        });
        return wheelCount > 0 && wheelCount < 4;
      },
      subtitle: 'Necessary for proper installation and eliminating vibrations in aftermarket wheels. We will refund it if it is not needed for your wheel.'
    },
    {
      id: 'vossenLugs',
      handle: 'vossen-wheel-lug-nuts-bolts-lock-combo-for-use-with-vossen-wheels-only',
      condition: function(cart){
        var count = 0;
        cart.items.forEach(function(item){
          if(
            item.vendor &&
            item.vendor.toLowerCase() === 'vossen' &&
            item.product_type &&
            item.product_type.toLowerCase() === 'wheels'
          ){
            count += item.quantity;
          }
        });
        return count >= 4;
      },
      subtitle: 'Vossen Lugs & Locks set - For use on Vossen wheels only!'
    },
    // Mount & Balance Eligible - auto add when 1+ wheels and 1+ tires
    {
      id: 'mountBalanceEligible',
      handle: 'mounting-and-balancing',
      // Auto-add when at least 1 wheel and 1 tire are in cart
      autoAddCondition: function(cart) {
        var wheelCount = 0, tireCount = 0;
        cart.items.forEach(function(item) {
          var pt = item.product_type ? item.product_type.toLowerCase() : "";
          if(pt === 'wheels') wheelCount += item.quantity;
          if(pt === 'tires') tireCount += item.quantity;
        });
        return wheelCount >= 1 && tireCount >= 1;
      },
      // Show as upsell if conditions are met and it was manually removed
      condition: function(cart) {
        var wheelCount = 0, tireCount = 0;
        cart.items.forEach(function(item) {
          var pt = item.product_type ? item.product_type.toLowerCase() : "";
          if(pt === 'wheels') wheelCount += item.quantity;
          if(pt === 'tires') tireCount += item.quantity;
        });
        
        console.log("Mount & Balance Eligible condition check - wheels:", wheelCount, 
                    "tires:", tireCount, 
                    "manually removed:", window.mountBalanceEligibleManuallyRemoved);
                    
        return wheelCount >= 1 && tireCount >= 1 && window.mountBalanceEligibleManuallyRemoved === true;
      },
      subtitle: 'Your order qualifies for mounting & balancing services at checkout!'
    }
  ];

  // Store product data
  var upsellData = {};

  // Fetch JSON for each upsell product
  var upsellPromises = [];
  upsells.forEach(function(upsell){
    var promise = $.getJSON('/products/' + upsell.handle + '.js', function(product){
      upsellData[upsell.id] = product;
    });
    upsellPromises.push(promise);
  });

  $.when.apply($, upsellPromises).done(function(){
    updateUpsells();
    
    // Hide Mount & Balance Eligible from cart on initial load
    setTimeout(hideMountBalanceEligibleFromCart, 500);
  });

  // Initialize manually removed flag
  window.mountBalanceEligibleManuallyRemoved = false;
  
  // Track last cart state to detect removals
  var lastCartState = {
    wheelCount: 0,
    tireCount: 0,
    hasMountBalanceEligible: false
  };
  
  // NEW: Flag to prevent recursive updates
  var isAdjustingMountBalanceEligible = false;
  
  // NEW FUNCTION: Check if mount & balance eligible would be the only item in cart
  function checkAndHandleSoloMountBalanceEligible(cart) {
    // Get mount & balance eligible product info
    var mountBalanceEligibleProduct = upsellData['mountBalanceEligible'];
    if (!mountBalanceEligibleProduct) return;
    
    var mountBalanceEligibleVariantIds = mountBalanceEligibleProduct.variants.map(function(v){ 
      return v.id; 
    });
    
    // Count items that are NOT mount & balance eligible
    var nonMountBalanceItemCount = 0;
    var mountBalanceEligibleItem = null;
    
    cart.items.forEach(function(item) {
      if (mountBalanceEligibleVariantIds.indexOf(item.variant_id) === -1) {
        nonMountBalanceItemCount++;
      } else {
        mountBalanceEligibleItem = item;
      }
    });
    
    // If mount & balance eligible would be alone in cart, remove it
    if (nonMountBalanceItemCount === 0 && mountBalanceEligibleItem) {
      console.log("Removing Mount & Balance Eligible as it would be the only item in cart");
      
      $.post('/cart/change.js', { 
        id: mountBalanceEligibleItem.key, 
        quantity: 0 
      }, function(response){
        updateCartDisplay();
      }, "json");
    }
  }
  
  // Fetch cart and update upsell blocks
  function updateUpsells(){
    $.getJSON('/cart.js', function(cart){
      var isVossenCart = cart.items.some(function(item){
        return (
          item.vendor &&
          item.vendor.toLowerCase() === 'vossen' &&
          item.product_type &&
          item.product_type.toLowerCase() === 'wheels'
        );
      });
      
      // Count wheels and tires in cart
      var currentWheelCount = 0;
      var currentTireCount = 0;
      cart.items.forEach(function(item) {
        var pt = item.product_type ? item.product_type.toLowerCase() : "";
        if(pt === 'wheels') currentWheelCount += item.quantity;
        if(pt === 'tires') currentTireCount += item.quantity;
      });
      
      // Check if mount & balance eligible is currently in cart
      var mountBalanceEligibleProduct = upsellData['mountBalanceEligible'];
      var mountBalanceEligibleVariantIds = mountBalanceEligibleProduct ? 
        mountBalanceEligibleProduct.variants.map(function(v){ return v.id; }) : [];
      var hasMountBalanceEligible = cart.items.some(function(item){
        return mountBalanceEligibleVariantIds.indexOf(item.variant_id) !== -1;
      });
      
      // Detect if mount & balance eligible was manually removed
      if (lastCartState.hasMountBalanceEligible && !hasMountBalanceEligible && 
          currentWheelCount >= 1 && currentTireCount >= 1 &&
          lastCartState.wheelCount >= 1 && lastCartState.tireCount >= 1) {
        console.log("Mount & Balance Eligible was manually removed");
        window.mountBalanceEligibleManuallyRemoved = true;
      }
      
      // Update last cart state
      lastCartState = {
        wheelCount: currentWheelCount,
        tireCount: currentTireCount,
        hasMountBalanceEligible: hasMountBalanceEligible
      };
      
      // Check if mount & balance eligible would be the only item in cart
      checkAndHandleSoloMountBalanceEligible(cart);
      
      // Only remove mount & balance eligible if either wheels or tires is 0
      if ((currentWheelCount === 0 || currentTireCount === 0) && hasMountBalanceEligible) {
        var mountBalanceVariantId = mountBalanceEligibleVariantIds[0];
        var mountBalanceCartItem = cart.items.find(function(item){
          return mountBalanceEligibleVariantIds.indexOf(item.variant_id) !== -1;
        });
        
        if (mountBalanceCartItem) {
          $.post('/cart/change.js', { 
            id: mountBalanceCartItem.key, 
            quantity: 0 
          }, function(response){
            console.log("Removed Mount & Balance Eligible due to no wheels or tires");
            updateCartDisplay();
          }, "json");
        }
        window.mountBalanceEligibleManuallyRemoved = false;
      }

      upsells.forEach(function(upsell){
        var product = upsellData[upsell.id];
        if(!product) return;

        var variantIds = product.variants.map(function(v){ return v.id; });
        var inCart = cart.items.some(function(item){
          return variantIds.indexOf(item.variant_id) !== -1;
        });

        // Check auto-add condition first - special handling for mountBalanceEligible
        if(upsell.autoAddCondition && upsell.autoAddCondition(cart)) {
          // Don't auto-add mountBalanceEligible if it was manually removed
          if(upsell.id === 'mountBalanceEligible' && window.mountBalanceEligibleManuallyRemoved) {
            // Skip auto-add and let it potentially show up as a recommendation
          } else if(!inCart) {
            // Auto-add with quantity 1 for mount & balance eligible
            var variantToAdd = (upsell.id === 'mountBalanceEligible') ? 45267843383447 : product.variants[0].id;
            var quantity = 1; // Always quantity 1 for mount & balance eligible
            
            $.post('/cart/add.js', { 
              id: variantToAdd, 
              quantity: quantity 
            }, function(response){
              console.log("Auto-added upsell (" + upsell.id + ") to cart with quantity:", quantity);
              
              // No need to reset manually removed flag here as we're not auto-adding if removed
              
              updateUpsells();
              updateCartDisplay();
            }, "json").fail(function(xhr, status, error){
              console.error("Error auto adding upsell product " + upsell.id, error);
            });
            
            $('#' + getUpsellElementId(upsell.id)).remove();
            return; // Skip further suggestion logic for this upsell
          } else {
            // Item already in cart
            $('#' + getUpsellElementId(upsell.id)).remove();
            return; // Skip further suggestion logic for this upsell
          }
        }

        if(upsell.condition(cart) && !inCart) {
          if(!$('#' + getUpsellElementId(upsell.id)).length){
            addUpsell(upsell, product);
          }
        } else {
          $('#' + getUpsellElementId(upsell.id)).remove();
        }
      });

      // If upsell container is empty, remove it; otherwise sort & toggle the heading
      var upsellContainer = $('#upsell-container');
      if(upsellContainer.length && upsellContainer.children('.upsell').length === 0){
        upsellContainer.remove();
      } else if(upsellContainer.length) {
        sortUpsellContainer(isVossenCart);
        maybeAddOrRemoveHeading();
      }
    });
  }

  // Return ID for an upsell block
  function getUpsellElementId(upsellId){
    return 'upsell-' + upsellId;
  }

  // Returns the upsell container if on cart page
  function getUpsellContainer(){
    var cartContainer = $('#main-cart-items');
    // If not on cart page, skip
    if(!cartContainer.length) return null;

    var container = $('#upsell-container');
    if(!container.length){
      container = $('<div id="upsell-container" style="margin-top:10px;"></div>');
      cartContainer.after(container);
    }
    return container;
  }

  // Add or remove the heading dynamically
  function maybeAddOrRemoveHeading(){
    var container = $('#upsell-container');
    if(!container.length) return;

    // If no upsells present, remove heading
    if(container.children('.upsell').length === 0) {
      container.find('h3.upsell-title').remove();
    } else {
      // If heading doesn't exist yet, add it
      if(!container.find('h3.upsell-title').length) {
        container.prepend('<h3 class="upsell-title" style="margin-bottom:20px;">Recommendations:</h3>');
      }
    }
  }

  // Build and insert an upsell block
  function addUpsell(upsell, product){
    var container = getUpsellContainer();
    if(!container) return; // Not on cart page
  
    var elementId = getUpsellElementId(upsell.id);
    var showDropdown = product.variants.length > 1;
    var variantOptionsHtml = '';
    if(showDropdown) {
      product.variants.forEach(function(variant){
        variantOptionsHtml += '<option value="' + variant.id + '">' + variant.title + '</option>';
      });
    }
  
    var defaultImage = (product.featured_image && product.featured_image.src)
      || (product.images && product.images.length > 0 ? product.images[0] : 'https://via.placeholder.com/100');
    
    // Hide price for mount & balance eligible, show for others
    var priceHtml = '';
    if (upsell.id !== 'mountBalanceEligible') {
      var priceFormatted = '$' + (product.price / 100).toFixed(2);
      priceHtml = '<p style="margin: 0 0 10px 0; font-weight:bold;">Price: ' + priceFormatted + '</p>';
    }
  
    var subtitleHtml = upsell.subtitle
      ? '<p style="margin: 0 0 5px 0;">' + upsell.subtitle + '</p>'
      : '';
  
    // Build options HTML based on whether there's more than one variant
    var optionsHtml = '';
    if(showDropdown) {
      optionsHtml = `
        <label for="${elementId}-variant-select" style="display:block; margin-bottom:5px;">Choose option:</label>
        <div style="display:flex; align-items:center;">
          <select id="${elementId}-variant-select" style="width:auto; margin-right:10px;">
            ${variantOptionsHtml}
          </select>
          <button type="button" id="${elementId}-add" style="background-color:black; color:white; border:none; padding:8px 16px; cursor:pointer;">ADD</button>
        </div>
      `;
    } else {
      optionsHtml = `<button type="button" id="${elementId}-add" style="background-color:black; color:white; border:none; padding:8px 16px; cursor:pointer;">ADD</button>`;
    }
  
    var html = `
      <div id="${elementId}" class="upsell" style="border:1px solid #ccc; padding:10px; margin-top:20px;">
        <div style="display:flex; align-items:center;">
          <div style="margin-right:10px;">
            <img id="${elementId}-img" src="${defaultImage}" alt="${product.title}" style="max-width:100px;">
          </div>
          <div style="flex:1;">
            <p style="margin: 0 0 5px 0; font-weight:bold;">
              <a href="/products/${product.handle}" style="text-decoration: none; color: inherit;">${product.title}</a>
            </p>
            ${subtitleHtml}
            ${priceHtml}
            ${optionsHtml}
          </div>
        </div>
      </div>
    `;
    container.append(html);
    console.log("Upsell suggestion (" + upsell.id + ") added to page.");
  
    // If dropdown exists, update image on variant change
    if(showDropdown){
      $('#' + elementId + '-variant-select').on('change', function(){
        var selectedId = $(this).val();
        var selectedVariant = product.variants.find(function(v){ return v.id == selectedId; });
        var newImage = (selectedVariant && selectedVariant.featured_image && selectedVariant.featured_image.src)
          ? selectedVariant.featured_image.src
          : defaultImage;
        $('#' + elementId + '-img').attr('src', newImage);
      });
    }
  
    // Add product to cart via AJAX; use selected variant if dropdown exists, otherwise use the only variant
    $('#' + elementId + '-add').on('click', function(e){
      e.preventDefault();
      var selectedVariantId = showDropdown
        ? $('#' + elementId + '-variant-select').val()
        : product.variants[0].id;
      
      // Always quantity 1 for mount & balance eligible
      var quantity = 1;
      
      $.post('/cart/add.js', { 
        id: selectedVariantId, 
        quantity: quantity 
      }, function(response){
        console.log("Upsell product (" + upsell.id + ") added to cart with quantity:", quantity);
        
        // If this is the mount & balance eligible product, reset the manually removed flag
        if (upsell.id === 'mountBalanceEligible') {
          window.mountBalanceEligibleManuallyRemoved = false;
          console.log("Reset manually removed flag after customer added mount & balance eligible");
        }
        
        $('#' + elementId).remove();
        updateCartDisplay();
      }, "json").fail(function(xhr, status, error){
        console.error("Error adding upsell product " + upsell.id, error);
      });
    });
  }

  // Reorder upsell blocks based on certain conditions
  function sortUpsellContainer(isVossenCart){
    var orderMapping;
    if(isVossenCart){
      orderMapping = {
        'vossenLugs': 1,
        'mountBalanceEligible': 2,
        'hubCentricRings': 3,
        'wheelInstallationKit': 4,
        'tpmsSensors': 5,
        'premiumWheelLocks': 6
      };
    } else {
      orderMapping = {
        'mountBalanceEligible': 1,
        'hubCentricRings': 2,
        'wheelInstallationKit': 3,
        'tpmsSensors': 4,
        'premiumWheelLocks': 5
      };
    }
    var container = $('#upsell-container');
    var upsellElements = container.children('.upsell').get();
    upsellElements.sort(function(a, b){
      var aId = $(a).attr('id').replace('upsell-','');
      var bId = $(b).attr('id').replace('upsell-','');
      var aOrder = orderMapping[aId] || 999;
      var bOrder = orderMapping[bId] || 999;
      return aOrder - bOrder;
    });
    $.each(upsellElements, function(idx, elem){
      container.append(elem);
    });
  }

  // Hide Mount & Balance Eligible from cart display
  function hideMountBalanceEligibleFromCart() {
    var mountBalanceEligibleProduct = upsellData['mountBalanceEligible'];
    if (!mountBalanceEligibleProduct) return;
    
    var mountBalanceEligibleVariantIds = mountBalanceEligibleProduct.variants.map(function(v){ 
      return v.id; 
    });
    
    // Common selectors for cart line items
    var cartItemSelectors = [
      '.cart-item',
      '.line-item', 
      '.cart__item',
      '[data-cart-item]',
      'tr[data-variant-id]',
      '.cart-items tr',
      '.js-cart-item'
    ];
    
    cartItemSelectors.forEach(function(selector) {
      $(selector).each(function() {
        var $item = $(this);
        var variantId = $item.attr('data-variant-id') || 
                       $item.find('[data-variant-id]').attr('data-variant-id') ||
                       $item.find('input[name*="updates"]').attr('name').match(/\d+/);
        
        if (variantId && mountBalanceEligibleVariantIds.includes(parseInt(variantId))) {
          console.log("Hiding Mount & Balance Eligible from cart display");
          $item.hide();
        }
      });
    });
    
    // Also try to hide by product name/title
    $('.cart-item, .line-item, .cart__item, tr').each(function() {
      var $item = $(this);
      var itemText = $item.text().toLowerCase();
      
      if (itemText.includes('mount') && itemText.includes('balance') && 
          (itemText.includes('eligible') || itemText.includes('mounting'))) {
        console.log("Hiding Mount & Balance Eligible by text match");
        $item.hide();
      }
    });
  }
  
  // Update the cart display after adding an upsell
  function updateCartDisplay(){
    $.get('/cart?view=ajax', function(html){
      var newCartRows = $(html).find('table.cart-items tbody').html();
      if(newCartRows){
        var tbody = $('#main-cart-items .js-contents table.cart-items tbody');
        tbody.html(newCartRows);
      }
      
      // Hide Mount & Balance Eligible after cart update
      setTimeout(hideMountBalanceEligibleFromCart, 100);
      
      updateUpsells();
      updateCartTotals();
    });
  }

  // Update cart subtotal
  function updateCartTotals(){
    $.getJSON('/cart.js', function(cart) {
      var formattedTotal = Shopify.formatMoney 
        ? Shopify.formatMoney(cart.total_price, "{{ amount_no_decimals_with_comma_separator }}")
        : "$" + (cart.total_price / 100).toFixed(2);
      $('.totals-subtotal-value').text(formattedTotal);
      
      // Additional check for solo mount & balance eligible after cart update
      checkAndHandleSoloMountBalanceEligible(cart);
      
      // Hide Mount & Balance Eligible from cart display
      setTimeout(hideMountBalanceEligibleFromCart, 100);
    });
  }

  // Observe #main-cart-items for changes
  var targetNode = document.getElementById('main-cart-items');
  if(targetNode){
    var observer = new MutationObserver(function(mutationsList, observer){
      // Get cart data and check for solo mount & balance eligible
      $.getJSON('/cart.js', function(cart) {
        checkAndHandleSoloMountBalanceEligible(cart);
        updateUpsells();
        updateCartTotals();
        
        // Hide Mount & Balance Eligible from cart display
        setTimeout(hideMountBalanceEligibleFromCart, 200);
      });
    });
    observer.observe(targetNode, { childList: true, subtree: true });
  } else {
    // Fallback if not on cart page
    setInterval(function(){
      $.getJSON('/cart.js', function(cart) {
        checkAndHandleSoloMountBalanceEligible(cart);
        updateUpsells();
        updateCartTotals();
        
        // Hide Mount & Balance Eligible from cart display
        setTimeout(hideMountBalanceEligibleFromCart, 200);
      });
    }, 3000);
  }

  // CSS for hover underline on upsell links and hiding mount & balance eligible
  if(!$('#upsell-styles').length){
    $('head').append(`
      <style id="upsell-styles">
        .upsell a:hover { text-decoration: underline; }
        
        /* Hide Mount & Balance Eligible from cart */
        .cart-item[data-product-title*="Mount"][data-product-title*="Balance"],
        .line-item[data-product-title*="Mount"][data-product-title*="Balance"],
        .cart__item[data-product-title*="Mount"][data-product-title*="Balance"],
        [data-cart-item][data-product-title*="Mount"][data-product-title*="Balance"] {
          display: none !important;
        } 
      </style>
    `);
  }
});